var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useEffect, useState } from "react";
import { getI18n, I18nextProvider } from "react-i18next";
import ccI18n from "../i18n";
import moment from "moment";
var CCI18nProvider = function (props) {
    var _a, _b, _c;
    var _d = useState(false), updating = _d[0], setUpdating = _d[1];
    var _e = useState(ccI18n.language), setMomentLocale = _e[1];
    useEffect(function () {
        var updateLocale = function () {
            void (function () { return __awaiter(void 0, void 0, void 0, function () {
                var e_1, e_2, htmlTag;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            setUpdating(true);
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, 3, 8, 9]);
                            return [4 /*yield*/, import("moment/locale/" + ccI18n.language.toLowerCase())];
                        case 2:
                            _a.sent();
                            return [3 /*break*/, 9];
                        case 3:
                            e_1 = _a.sent();
                            _a.label = 4;
                        case 4:
                            _a.trys.push([4, 6, , 7]);
                            return [4 /*yield*/, import("moment/locale/" + ccI18n.language.split("-")[0].toLowerCase())];
                        case 5:
                            _a.sent();
                            return [3 /*break*/, 7];
                        case 6:
                            e_2 = _a.sent();
                            return [3 /*break*/, 7];
                        case 7: return [3 /*break*/, 9];
                        case 8:
                            moment.locale(ccI18n.language);
                            setMomentLocale(ccI18n.language);
                            htmlTag = document.querySelector("html");
                            if (htmlTag)
                                htmlTag.lang = ccI18n.language.split("-")[0];
                            setUpdating(false);
                            return [7 /*endfinally*/];
                        case 9: return [2 /*return*/];
                    }
                });
            }); })();
        };
        updateLocale();
        ccI18n.on("languageChanged", updateLocale);
        return function () { return ccI18n.off("languageChanged", updateLocale); };
    }, []);
    return (React.createElement(I18nextProvider, { i18n: (_a = getI18n()) !== null && _a !== void 0 ? _a : ccI18n, 
        // defaultNS used to force refresh
        defaultNS: updating ? (_c = ((_b = getI18n()) !== null && _b !== void 0 ? _b : ccI18n).options.defaultNS) !== null && _c !== void 0 ? _c : "" : undefined }, props.children));
};
export default React.memo(CCI18nProvider);
